import React, { useMemo, FC } from "react"
import Styles from "../styles/PageLinkText.module.scss"
import UserAvatar from "./UserAvatar"
import { Link } from "gatsby"
import moment from "moment"
import ActivityIndicator from "./atoms/ActivityIndicator";
import { linkPageObjectType, ImageLinkPageObjectType, VideoLinkPageObjectType, isVideoLinkObject, isImageLinkObject } from "./PageLinkText"


type LinkPageComponentProps = {
    linkPageObject: linkPageObjectType
    fetching: boolean
}

export const LinkPageComponent: FC<LinkPageComponentProps> = ( { linkPageObject, fetching } ) => {
    const renderMedia = ( linkPageObject: VideoLinkPageObjectType | ImageLinkPageObjectType ) =>
        <div className={ Styles.image_wrapper }>
            <img
                className={ Styles.image }
                src={
                    isVideoLinkObject( linkPageObject ) ?
                        linkPageObject.thumbnail :
                        linkPageObject.file } />
        </div>

    const renderLinkPage = () =>
        linkPageObject &&
        <Link
            to={ `/post/${ linkPageObject.pk }` }
            state={ {
                postID: linkPageObject.pk,
                post: linkPageObject
            } }
            className={ Styles.container }>
            <div className={ Styles.link_container }>
                <div className={ Styles.info_container }>
                    <div className={ Styles.author_wrapper }>
                        { linkPageObject.author ?
                            <UserAvatar
                                userName={ linkPageObject.author.name }
                                userID={ linkPageObject.author.pk }
                                profileImageURL={ linkPageObject.author.profile_image_100 }
                                size={ 32 }
                                avatarSize={ 16 }
                                style={ { height: 32, width: 32 } } /> :
                            <UserAvatar
                                size={ 32 }
                                avatarSize={ 16 }
                                style={ { height: 32, width: 32 } } />
                        }
                        { <span className={ Styles.author_name }>
                            { linkPageObject.author ?
                                linkPageObject.author.name :
                                "匿名ユーザー" }
                        </span> }
                    </div>
                    <span className={ Styles.date }>{ `${ moment( linkPageObject.created_at ).format( 'YYYY年MM月DD日' ) }` }</span>
                </div>
                <div className={ Styles.content }>
                    { linkPageObject.text &&
                        <p className={ Styles.text }>{ linkPageObject.text }</p> }
                    { ( isVideoLinkObject( linkPageObject ) || isImageLinkObject( linkPageObject ) ) &&
                        renderMedia( linkPageObject ) }
                </div>
            </div>
        </Link>

    return useMemo( () =>
        <div style={ { display: "flex", flexDirection: "column", width: "100%" } }>
            { fetching ?
                <ActivityIndicator /> :
                renderLinkPage() }
        </div>, [ linkPageObject, fetching ] )
}
